// Custom date-range picker used by the Dashboard.
// NOTE: the start input must display startDate and the end input endDate —
// these were swapped historically, which made single-day selection look broken.
// min/max keep the range ordered (start <= end).
const DateComponent = (props: any) => {
  const handleChangeStartDate = (e: any) => {
    const startDate = e?.target?.value;
    if (startDate) props?.selecetedStartDate(startDate);
  };
  const handleChangeEndDate = (e: any) => {
    const endDate = e?.target?.value;
    if (endDate) props?.selectedEndDate(endDate);
  };
  return (
    <div className="datecom flex border border-aqua rounded-3xl w-80 h-10 p-2 justify-around ">
      <input
        type="date"
        onChange={(e) => handleChangeStartDate(e)}
        className="outline-none "
        id="date"
        value={props.startDate}
        max={props.endDate || undefined}
      />
      <p className="border-r border-aqua"></p>
      <input
        type="date"
        onChange={(e) => handleChangeEndDate(e)}
        className="outline-none"
        id="dates"
        value={props.endDate}
        min={props.startDate || undefined}
      />
    </div>
  );
};

export default DateComponent;
